<div class="translatable-label">
    <dvb-translatable-language ng-model="vm.language"></dvb-translatable-language>

    <p ng-bind="(vm.isLanguageEmpty(vm.language) ? vm.translation.texts[vm.language] : ('LANGUAGE.NO_TEXT_DEFINED' | translate))"
       ng-class="{'placeholder-color': !vm.isLanguageEmpty(vm.language), 'truncate': vm.truncate, 'pre-wrap': vm.prewrap}"></p>
</div>
